<template>
  <header id="header">
    <div class="logo">
      <span style="font-size: 24px; font-weight: bold; color: #fff; line-height: 75px;"><img :src="cssType==0?logo:logo1"></span>
    </div>
    <div class="right">
      <!-- <div>官网</div>
            <div>服务与支持</div> -->
      <div style="height: 75px; position: absolute;left: 0; right: 225px;"
        @mouseover="newsShow=false;detailsShow=false"> </div>

      <div class="tidings c-pointer" @mouseover="newsShow=false;detailsShow=false" @click="clickjy(1)"
        v-show="!$store.state.userConfig.mute"><img :src="jy"></div>
      <div class="tidings c-pointer" @mouseover="newsShow=false;detailsShow=false" @click="clickjy(0)"
        v-show="$store.state.userConfig.mute"><img :src="jy1"></div>
      <div class="tidings c-pointer" @mouseover="newsShow=true;detailsShow=false"
        @blur="newsShow=false;detailsShow=false" @click="$router.push({path:'/Message'})"><img :src="tidings" /> <img
          :src="red" v-show="regState()" class="top-red" /></div>
      <div class="mydata c-pointer" @mouseover="detailsShow=true;newsShow=false"
        @click="$router.push({path:'/userProfile'})"><img :src="`${$store.state.imgUrl+$store.state.userData.avatar}`"
          class="avatar" /> <img :src="look" v-show="$store.state.isLook" class="look"></div>
      <div @mouseover="newsShow=false;detailsShow=false"
        style="width: 15px; height: 75px; position: absolute; right: 0;"></div>
      <div @mouseover="newsShow=false;detailsShow=false"
        style="width: 225px; height: 5px; position: absolute; right: 0; top: 0;"></div>
    </div>
    <div class="user-box clearfix" v-show="detailsShow" @mouseleave="detailsShow=false">
      <p class="title"><span @click="$router.push({path:'/userProfile'})" style="cursor: pointer;">进入个人中心</span>
        <span class="see" v-show="!$store.state.isLook" @click="enterGuestMode">进入查看模式</span>
        <span class="see" v-show="$store.state.isLook" @click="popup">退出查看模式</span>
      </p>
      <div class="user-details">
        <p>用户详情</p>
        <p>账号：{{$store.state.userData.userName}}</p>
        <p>姓名：{{$store.state.userData.displayName}}</p>
        <p>组织：{{$store.state.userData.groupName}}</p>
        <p>公众号：{{$store.state.userData.wechatId=="" || $store.state.userData.wechatId== null ? '未绑定':"已绑定"}}</p>
      </div>
      <div class="btn-box">
        <el-button type="primary" class="btn" @click="logout">退出登录</el-button>
      </div>
      <span class="triangle"></span>
    </div>
    <div class="news-box clearfix" v-show="newsShow" @mouseleave="newsShow=false">
      <p class="news-title">消息提示</p>
      <div class="scorll-box">
        <p v-for="(msg,m) in $store.state.messageList" :class="{'read':msg.state==1}">{{msg.context}}</p>
        <p v-if="$store.state.messageList.length==0">当前没有消息通知</p>
      </div>
      <p class="lookAll" @click="$router.push({path:'/Message'})">查看全部</p>
      <span class="triangle rigth-50"></span>
    </div>
    <!-- 弹窗 -->
    <div class="popup" v-show="popupShow">
      <div class="exit-guest">
        <div class="popup-title">
          验证身份<i class="el-icon-circle-close close" @click="close"></i>
        </div>
        <div class="popup-lab">
          <p>请输入密码：</p>
          <el-form :model="ruleForm" :rules="rules" ref="passForm" @submit.native.prevent>
            <el-form-item prop="password">
              <el-input v-model="ruleForm.password" show-password @keyup.enter.native="exitGuestMode"></el-input>
            </el-form-item>
          </el-form>
        </div>
        <p class="btn-box">
          <el-button type="primary" @click="exitGuestMode">确定</el-button>
          <el-button @click="close">取消</el-button>
        </p>
      </div>
    </div>
  </header>
</template>
<script>
  export default {
    data() {
      return {
        logo: require("@/assets/image/index/logo.png"),
        logo1: require("@/assets/image/index/tjcloud.png"),
        tidings: null,
        red: require('@/assets/image/header/red.png'),
        look: require('@/assets/image/index/see.png'),
        jy: require('@/assets/image/header/jy.png'),
        jy1: require('@/assets/image/header/jy1.png'),
        remindAudio: require('@/assets/video/remind.mp3'),
        detailsShow: false,
        popupShow: false,
        newsShow: false,
        ruleForm: {
          password: "",
        },
        audio:null,
        time2:null,
        rules: {
          password: [{
            required: true,
            message: "密码不能为空",
            trigger: 'blur'
          }]
        },
        state: 1,
      }
    },

    computed: {
      broadcasting() {
        return this.$store.state.broadcasting
      },
      mute(){
        return this.$store.state.userConfig.mute
      },
    },
    created() {
      this.tidings = require('@/assets/image/header/tidings' + this.cssType + '.png')
    },
    methods: {
      // 播放提示
      playRemind() {
        if (this.mute||this.time2) {
          return
        }
        this.audio = new Audio()
        this.audio.src = this.remindAudio
        this.audio.play()
        this.time2 = setTimeout(() => {
          this.audio.pause()
          clearTimeout(this.time2)
          this.time = null
        }, 15000)
      },
      clickjy(v) {
        this.postNoJson('/UserConfig/set', {
          name: 'mute',
          value: v
        }).then(res => {
          if (res.success) {
            this.$store.state.userConfig.mute = v
          } else {
            this.$message({
              type: 'warning',
              message: `设置失败: ${res.message}`
            });
          }
        })
      },
      //退出查看模式
      exitGuestMode() {
        this.$refs.passForm.validate((valid) => {
          if (valid) {
            let parm = {
              password: this.ruleForm.password
            };
            this.post('/UserProfile/exitGuestMode', parm).then((res) => {
              if (res.success) {
                this.$message({
                  type: 'success',
                  message: `退出成功`
                });
                localStorage.setItem('isLook', false)
                this.$store.state.isLook = false;
                this.$store.state.mask = false;
                this.popupShow = false;
                this.$store.commit('changeLook', false);
                this.lookTime(localStorage.getItem('guestTime'))
                this.ruleForm.password = "";
              } else {
                this.$message({
                  type: 'warning',
                  message: `退出失败: ${res.message}`
                });
              }
            })
          }
        })

      },
      //进入查看模式
      enterGuestMode() {
        this.get('/UserProfile/enterGuestMode').then((res) => {
          if (res.success) {
            localStorage.setItem('isLook', true)
            this.$store.commit('changeLook', true);
            // clearInterval(this.timeInterval)
            localStorage.removeItem('lastClickTime')
          }
        })
      },
      //退出登录
      logout() {
        this.get('/UserProfile/logout').then((res) => {
          if (res.success) {
            localStorage.removeItem('userData');
            localStorage.removeItem("loginState");
            localStorage.removeItem('indexLoad')
            sessionStorage.removeItem('routerNext');
            this.$store.commit('changeLook', false);
            localStorage.setItem('isLook', false);
            localStorage.removeItem('lastClickTime');
            this.$store.state.userData = null;
            this.$store.state.loginState = false;
            this.$router.push({
              path: this.cssType == 0 ? '/login' : '/TJCloudLogin'
            });
            // clearInterval(this.timeInterval)
            // console.log(this.timeInterval)
          } else {
            this.$message({
              type: 'warning',
              message: '退出失败'
            });
          }
        })
      },
      //关闭弹窗
      close() {
        this.popupShow = false;
        this.$store.state.mask = false;
        this.password = "";
      },
      //显示弹窗
      popup() {
        this.detailsShow = false;
        this.popupShow = true;
        this.$store.state.mask = true;
      },
      // 消息状态
      regState() {
        let state = false
        for (let item of this.$store.state.messageList) {
          if (!state && item.state == 2) {
            state = true
            this.playRemind()
          }
        }
        return state
      },
    },
  }
</script>

<style scoped>
  #header {
    width: 100%;
    height: 75px;
    background-color: #2f3a4e;
    /* position: fixed;
        z-index: 0; */
    min-width: 1366px;
    position: relative;
  }

  #header .logo {
    width: 250px;
    line-height: 48px;
    height: 75px;
    float: left;
    background-color: #5087e4;
  }

  .logo img {
    margin-top: 15px;
  }

  #header .right {
    float: right;
    padding-right: 30px;
    box-sizing: border-box;
  }

  .right div {
    color: #fff;
    display: inline-block;
    font-size: 16px;
    line-height: 75px;
  }

  .right .tidings {
    position: relative;
    top: 10px;
    margin-right: 34px;
  }

  .right .mydata {
    position: relative;
    top: 15px;
  }

  .mydata .avatar {
    border-radius: 50%;
    width: 45px;
    height: 45px;
  }

  /* .right div:first-child{
        margin-right: 34px;
    } */
  .right .top-red {
    position: absolute;
    top: 10px;
    left: 20px;
  }

  .user-box,
  .news-box {
    width: 432px;
    height: 340px;
    background-color: #fff;
    position: absolute;
    right: 14px;
    top: 86px;
    z-index: 9999;
    padding: 0 32px;
    box-sizing: border-box;
    text-align: left;
    box-shadow: 2px 2px 7px 2px rgb(0 0 0 / .2);
  }

  .news-box {
    right: 66px !important;
  }

  .title {
    line-height: 52px;
    font-size: 14px;
    color: #5087e4;
    border-bottom: 1px solid #dcdcdc;
    background-color: #fff;
  }

  .news-title {
    font-size: 16px;
    line-height: 46px;
  }

  .scorll-box p {
    line-height: 46px;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
    font-size: 14px;
    border-bottom: 1px solid #dcdcdc;
  }

  .scorll-box>p:last-child {
    border: 0;
  }

  .scorll-box {
    height: 234px;
    overflow-y: auto;
    overflow-x: hidden;
    border-top: 1px solid #dcdcdc;
    border-bottom: 1px solid #dcdcdc;
  }

  .user-details {
    padding-top: 12px;
    background-color: #fff;
  }

  .user-details>p {
    line-height: 34px;
    font-size: 14px;
  }

  .btn-box {
    text-align: center;
    margin-top: 40px;
    background-color: #fff;
  }

  .details,
  .see {
    color: #5087e4;
    cursor: pointer;
  }

  .see {
    float: right;
    font-size: 14px;
  }

  .triangle {
    width: 0;
    height: 0;
    border-right: 10px solid transparent;
    border-left: 10px solid transparent;
    border-bottom: 20px solid #fff;
    position: absolute;
    top: -20px;
    right: 28px;
  }

  .rigth-50 {
    right: 50px !important;
  }

  .look {
    width: 20px;
    position: absolute;
    bottom: 25px;
    right: -5px;
  }

  .lookAll {
    text-align: center;
    font-size: 14px;
    margin-top: 18px;
    cursor: pointer;
    color: #5087e4;
  }

  .read {
    color: #b1b1b1 !important;
  }

  /* 弹窗 */
  .popup>div {
    position: fixed;
    top: 150px;
    left: 50%;
    width: 498px;
    height: 308px;
    padding: 0 28px;
    box-sizing: border-box;
    margin-left: -249px;
    background-color: #fff;
    z-index: 1000 !important;
    padding-bottom: 30px;
  }

  .popup-title {
    font-size: 16px;
    line-height: 64px;
    border-bottom: 1px solid #e5e5e5;
    margin-bottom: 22px;
    text-align: left;
  }

  .popup-lab {
    text-align: left;
    font-size: 14px;
    line-height: 30px;
    margin-bottom: 14px !important;
    margin-top: 22px !important;
  }

  i.close {
    font-size: 20px;
    float: right;
    margin-top: 24px;
  }

  .btn-box {
    position: absolute;
    text-align: center;
    bottom: 36px;
    width: 100%;
    left: 0;
  }

  .btn-box .el-button {
    padding: 0 34px !important;
    line-height: 34px !important;
    margin: 0 20px;
  }
</style>
<style>
  #header .popup .el-input__inner {
    line-height: 34px !important;
    height: 34px !important;
    padding: 0 10px !important;
  }
</style>



// WEBPACK FOOTER //
// src/components/PublicAssembly/header.vue